import { ThemeProvider } from "@mui/material";
import { FairPaySurveyResponseProvider } from "contexts/FairPaySurveyResponse";
import { Navigate, Route, Routes } from "react-router-dom";
import surveyTheme from "styles/surveyTheme";

import SurveyWrapper from "./Survey";
import SurveySplashPage from "./SurveySplash";

export default function FairPaySurvey() {
  return (
    <ThemeProvider theme={surveyTheme}>
      <Routes>
        <Route
          path="/:surveyUuid/*"
          element={
            <FairPaySurveyResponseProvider>
              <SurveyWrapper />
            </FairPaySurveyResponseProvider>
          }
        />
        <Route path="/start" element={<SurveySplashPage />} />
        <Route path="/" element={<Navigate to="start" replace={true} />} />
      </Routes>
    </ThemeProvider>
  );
}
